export const DEFAULT_LOCATION_LONGITUDE = 126.98582959999999;
export const DEFAULT_LOCATION_LATITUDE = 37.55998;
export const DEFAULT_LOCATION_REGION_CODE = '1114055000';

export const DEFAULT_DATE_FORMAT = 'DD-MM-YYYY';
export const DEFAULT_DATE_TIME_FORMAT = 'DD-MM-YYYY HH:mm:ss';

export const MAXIMUM_RECENT_AREA_SEARCH = 10;

export const LOCATION_TYPE = {
  current: 'current',
  region: 'region'
}

export const INTENT_LOCATION_TYPE_KEY = 'INTENT_LOCATION_TYPE_KEY';

export const KEY_LATEST_LATITUDE = 'KEY_LATEST_LATITUDE';
export const KEY_LATEST_LONGITUDE = 'KEY_LATEST_LONGITUDE';

export const KEY_ENABLE_CURRENT_LOCATION = 'KEY_ENABLE_CURRENT_LOCATION';
export const KEY_ENABLE_INTERESTED_LOCATIONS = 'KEY_ENABLE_INTERESTED_LOCATIONS';

export const KEY_FIRST_INTERESTED_LOCATIONS_REGION_CODE = 'KEY_FIRST_INTERESTED_LOCATIONS_REGION_CODE';
export const KEY_FIRST_INTERESTED_LOCATIONS_REGION_CODE_CURRENT_LOCATION = 'KEY_FIRST_INTERESTED_LOCATIONS_REGION_CODE_CURRENT_LOCATION';

export const DEFAULT_PAGER_GAP = 20;

export const KEY_LATEST_CURRENT_LOCATION_WEATHER_NOW_RESPONSE = 'KEY_LATEST_CURRENT_LOCATION_WEATHER_NOW_RESPONSE';
export const KEY_LATEST_CURRENT_LOCATION_FORECAST_THREE_RESPONSE = 'KEY_LATEST_CURRENT_LOCATION_FORECAST_THREE_RESPONSE';
export const KEY_LATEST_CURRENT_LOCATION_FORECAST_TODAY_RESPONSE = 'KEY_LATEST_CURRENT_LOCATION_FORECAST_TODAY_RESPONSE';
export const KEY_LATEST_CURRENT_LOCATION_GET_BY_CODE_RESPONSE = 'KEY_LATEST_CURRENT_LOCATION_GET_BY_CODE_RESPONSE';